import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import { getOrderMSTeamMemberListDataByMOMSId } from '../orderMSTeamMembers/mockData'
import { getOrderMSContactListDataByMOMSId } from '../orderMSContacts/mockData'
import { getOrderMSDocumentListDataByMOMSId } from '../orderMSDocuments/mockData'
import { getOrderMSNoteListDataByMOMSId } from '../orderMSNotes/mockData'
import {
  getOrderMSServiceListDataByMOMSId,
  _getMOMSSListDataByMOMSId,
} from '../orderMSServices/mockData'
import { getCompanyMasterServiceSelectItemDataById } from '../companyMasterServices/mockData'
import { getOrderDataById } from '../orders/mockData'
import { getLocationListDataByCompanyId } from '../locations/mockData'
import { getCompanyDataById } from '../companies/mockData'
import {
  getOrderMasterServiceStatusById,
  OrderMasterServicesStatusIds,
} from '@/services/selectLists/orderMasterServicesStatii'
import { OrderMSServicesStatusIds } from '~/services/selectLists/orderMSServicesStatii'
import type { IOrderMasterService, IOrderMSService } from '~/types/order/models'
import type { IEntitySelectItemWithOptionalAvatar } from '~/types/models'
import { assertIsString } from '~/types/models'

const mn = '[api/msw/api/orderMasterServices/mockData.ts]'

const orderMasterServiceListData = undefined as unknown as IOrderMasterService[]

export const getOrderMasterServiceListData = getListDataFunctionFactory<
  IOrderMasterService[]
>({
  listData: orderMasterServiceListData,
  storageKey: 'ordermasterservices',
  getStartingListData: getStartingOrderMasterServiceListData,
  forOfFunction: async (ordms) => {
    ordms.orderMSServices = await getOrderMSServiceListDataByMOMSId(ordms.id)
    ordms.orderMSTeamMembers = await getOrderMSTeamMemberListDataByMOMSId(
      ordms.id
    )
    ordms.orderMSContacts = await getOrderMSContactListDataByMOMSId(ordms.id)
    ordms.orderMSDocuments = await getOrderMSDocumentListDataByMOMSId(ordms.id)
    ordms.orderMSNotes = await getOrderMSNoteListDataByMOMSId(ordms.id)
  },
})

export async function getOrderMasterServiceDataById(id: string) {
  const ordmsList = await getOrderMasterServiceListData()
  if (!ordmsList) {
    throw new Error(`getOrderMasterServiceListData returned undefined/null`)
  }
  const orderMasterService = ordmsList.find(
    (ordms: IOrderMasterService) => ordms.id === id
  )
  return orderMasterService
}

export async function getOrderMasterServiceListDataByOrderId(
  id: string
): Promise<IOrderMasterService[]> {
  const list = await getOrderMasterServiceListData()
  if (!list) {
    throw new Error(`getOrderMasterServiceListData returned undefined/null`)
  }
  const ordmsList = list.filter((ordms) => ordms.order.id === id) ?? []
  return ordmsList
}

export async function getPotentialLocationSelectItemListDataByMOMSId(
  id: string
) {
  const orderMasterService = await getOrderMasterServiceDataById(id)
  if (!orderMasterService) {
    throw new Error(`getOrderMasterServiceDataById returned undefined/null`)
  }
  const orderId = orderMasterService.order.id
  if (typeof orderId !== 'string') {
    throw new TypeError(`orderId is not type 'string'`)
  }
  const order = await getOrderDataById(orderId)
  if (!order) {
    throw new Error(`getOrderDataById returned undefined/null`)
  }
  if (typeof order.company.id !== 'string') {
    throw new TypeError(`order.company.id is not type 'string'`)
  }
  const locationListData = await getLocationListDataByCompanyId(
    order.company.id
  )
  return locationListData.map((loc) => {
    return { id: loc.id, label: loc.nickname }
  })
}

export async function getCompanyDataByOrderMasterServiceId(id: string) {
  const ordms = await getOrderMasterServiceDataById(id)
  if (!ordms) {
    throw new Error(`getOrderMasterSServiceDataById returned undefined/null`)
  }
  assertIsString(ordms.order.id)
  const order = await getOrderDataById(ordms.order.id)
  if (!ordms) {
    throw new Error(`getOrderMasterSServiceDataById returned undefined/null`)
  }
  assertIsString(order.company.id)
  const company = await getCompanyDataById(order.company.id)
  if (!company) {
    throw new Error(`getCompanyDataById returned undefined/null`)
  }
  return company
}

export async function getOrderDataByOrderMasterServiceId(id: string) {
  const ordms = await getOrderMasterServiceDataById(id)
  if (!ordms) {
    throw new Error(`getOrderMasterSServiceDataById returned undefined/null`)
  }
  assertIsString(ordms.order.id)
  const order = await getOrderDataById(ordms.order.id)
  if (!ordms) {
    throw new Error(`getOrderMasterSServiceDataById returned undefined/null`)
  }
  return order
}

export async function getSupplierListDataByOrderMasterServiceId(
  id: string,
  onlyWithReadyForContractMSServices: boolean = false
): Promise<IEntitySelectItemWithOptionalAvatar[]> {
  const fn = `${mn} getSupplierDataByOrderMasterServiceId |`
  const oms = await getOrderMasterServiceDataById(id)
  if (!oms) {
    throw new Error(`getOrderMasterSServiceDataById returned undefined/null`)
  }
  if (!oms.orderMSServices) {
    console.debug(`${fn} oms has no omss. Can't get omss supplier listData'`)
    return []
  }
  return oms.orderMSServices.reduce(
    (unique: IEntitySelectItemWithOptionalAvatar[], omss: IOrderMSService) => {
      if (omss.supplier && omss.doInclude) {
        if (
          !onlyWithReadyForContractMSServices ||
          omss.status.id === OrderMSServicesStatusIds.READY_FOR_CONTRACT
        ) {
          if (!unique.some((obj) => obj.id === omss.supplier?.id)) {
            unique.push(omss.supplier)
          }
        }
      }
      return unique
    },
    []
  )
}

export async function getStartingOrderMasterServiceListData(): Promise<
  IOrderMasterService[]
> {
  return [
    {
      id: 'XXORDMS0001',
      hrid: 'ORDMS0001',
      descr: 'DIA - Target & Big Mac',
      order: { id: 'XXORD0001', label: 'DIA - Target & Big Mac' },
      origin: {
        id: 2,
        label: 'Existing',
      },
      companyMasterService: await getCompanyMasterServiceSelectItemDataById(
        'XXCMS0001'
      ),
      project: {
        id: 'XXP0002',
        label: 'E-LAN to DIA Migration',
      },
      term: 36,
      numLocations: 0,
      numServices: 0,
      momssStatusCounts: [],
      status: getOrderMasterServiceStatusById(
        OrderMasterServicesStatusIds.READY_FOR_CONTRACTS
      )!,
      version: '1',
      canBeDeleted: false,
      orderMSServices: [], // Will be set by forOfFn  _getOMSSListDataByMOMSId('XXORDMS0001', mordmssList),
      orderMSTeamMembers: [], // Will be set by forOfFn  await getOrderMSTeamMemberListDataByMOMSId(
      orderMSContacts: [], // Will be set by forOfFn
      orderServiceOrders: [], // Will be set by forOffn
    },
    /**
     * XXORDMS0002 -- the order-side counterpart of the opportunity master
     * service XXOMS0005, created by the same signing routine as XXORD0002.
     *
     * `_buildOrderMasterServicesFromOpportunityMasterServices` copies `descr`,
     * `origin`, `term` and `project` from XXOMS0005 and writes the
     * `opportunityMasterService` back-reference that lets a LATER signature on
     * the same opportunity find this row and append to it rather than build a
     * second one. XXORDMS0001 has no such back-reference, which is one of the
     * signals that it was not built this way -- see the XXORD0002 comment.
     *
     * No `companyMasterService`: that key is copied only when the opportunity
     * master service has one, and XXOMS0005 does not.
     */
    {
      id: 'XXORDMS0002',
      hrid: 'ORDMS0002',
      descr: 'DIA - Boston, Lake & Waltham',
      order: { id: 'XXORD0002', label: 'DIA - Boston, Lake & Waltham' },
      origin: {
        id: 1,
        label: 'New',
      },
      opportunityMasterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
      },
      project: {
        id: 'XXP0002',
        label: 'E-LAN to DIA Migration',
      },
      term: 36,
      numLocations: 0,
      numServices: 0,
      momssStatusCounts: [],
      status: getOrderMasterServiceStatusById(
        OrderMasterServicesStatusIds.PREORDER
      )!,
      version: '1',
      canBeDeleted: false,
      orderMSServices: [], // Will be set by forOfFn
      orderMSTeamMembers: [], // Will be set by forOfFn
      orderMSContacts: [], // Will be set by forOfFn
      orderServiceOrders: [], // Will be set by forOfFn
    },
  ]
}
